const usePermissionConfig = () => {
  return {
    /*
    * 创建证书配置
    * 控制：创建证书配置
    * 跳转路由名称：
    * */
    CREATE: 'OPS-AGL-TZPZGL-CJZSPZ',
    /*
    * 编辑
    * 控制：编辑
    * 跳转路由名称：
    * */
    UPDATE: 'OPS-AGL-TZPZGL-BJ',
    /*
    * 终止
    * 控制：终止
    * 跳转路由名称：
    * */
    ENABLE: 'OPS-AGL-TZPZGL-ZZ',
    /*
    * 操作记录
    * 控制：操作记录
    * 跳转路由名称：
    * */
    LOG: 'OPS-AGL-TZPZGL-CZJL',
  };
};

export default usePermissionConfig;
